import { useState } from "react";
import { BookOpen, Bike, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { imgUrl } from "@/lib/api";
import { LinkQrCard, SmallQr } from "./LinkQrCard";

export function LinksQrTab({ base, tenant, settings, tables }) {
  const [amb, setAmb] = useState("Varanda");
  const slug = tenant.menu_slug;
  const poster = { store: tenant.nome_fantasia, color: settings.brand_color, logo: settings.logo_url ? imgUrl(settings.logo_url) : "" };
  return (
    <div className="space-y-8" data-testid="links-qr-tab">
      <div className="grid xl:grid-cols-2 gap-4">
        <LinkQrCard icon={BookOpen} title="Cardápio digital" testId="link-menu" url={base} file={`cardapio-${slug}`}
          desc="O cliente vê o cardápio e pede para consumir no local, na mesa ou para retirar."
          poster={{ ...poster, title: "Veja nosso cardápio", subtitle: "Escolha e peça pelo celular" }} />
        <LinkQrCard icon={Bike} title="Delivery" testId="link-delivery" url={`${base}?modo=delivery`} file={`delivery-${slug}`}
          desc="Abre direto no pedido para entrega. Ideal para redes sociais, WhatsApp e panfletos."
          poster={{ ...poster, title: "Peça seu delivery", subtitle: "Faça seu pedido pelo celular" }} />
      </div>
      <div className="space-y-3">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="font-semibold">Mesas e ambientes</p>
            <p className="text-sm text-muted-foreground">QR Codes que já identificam a mesa ou o ambiente no pedido.</p>
          </div>
          <div className="flex flex-wrap items-end gap-2">
            <Field label="Ambiente"><Input value={amb} onChange={(e) => setAmb(e.target.value)} data-testid="qr-ambiente-input" /></Field>
            <Button variant="outline" onClick={() => window.print()} data-testid="print-qr-btn"><Printer className="h-4 w-4 mr-1" />Imprimir todos</Button>
          </div>
        </div>
        <div className="print-area grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          <SmallQr title={`Ambiente: ${amb}`} url={`${base}?ambiente=${encodeURIComponent(amb)}`} file={`ambiente-${slug}`} testId="qr-ambiente" />
          {tables.map((tb) => <SmallQr key={tb.id} title={`Mesa ${tb.number}${tb.name ? ` · ${tb.name}` : ""}`} url={`${base}?mesa=${tb.number}`} file={`mesa-${tb.number}-${slug}`} testId={`qr-table-${tb.number}`} />)}
        </div>
      </div>
    </div>
  );
}
